// @ts-check
const path = require('path');
const {
  SUPPORTED_LOCALES_OBJ,
  SUPPORTED_LOCALES_ARR,
} = require('@zep-us/i18n');
const {
  createNextI18nextConfig,
} = require('../../packages/app-i18n/src/core/nextI18nextConfig');

// ns 는 serverSideTranslations 가 페이지마다 고르므로 지정하지 않는다.
// fallbackLng false 유지 — 폴백 리소스까지 HTML 에 실리면 응답이 커진다. 번역이 비면 키가
// 보이는 대신, 없는 키는 tsgo 가, 로케일별 누락은 _scripts/i18n/check-locale-parity.mjs 가 막는다.
module.exports = createNextI18nextConfig({
  locales: SUPPORTED_LOCALES_ARR,
  defaultLocale: SUPPORTED_LOCALES_OBJ.ko,
  fallbackLng: false,
  localeDetection: false,
  localePath: path.resolve('./public/locales'),
});
